import { fromJS } from 'immutable';

import SubscriptionRecord from 'records/subscription';
import baseReducer from 'redux/baseReducer';
import { createSymbols } from 'utils/helpers';

const initialState = fromJS({
    data: SubscriptionRecord({}),
    hasFetched: false,
    isFetching: false,
    loading: false,
});

export const {
    DELETE_SUBSCRIPTION,
    DELETE_SUBSCRIPTION_FAIL,
    DELETE_SUBSCRIPTION_SUCCESS,
    FETCH_SUBSCRIPTION,
    FETCH_SUBSCRIPTION_FAIL,
    FETCH_SUBSCRIPTION_SUCCESS,
    POST_SUBSCRIPTION,
    POST_SUBSCRIPTION_FAIL,
    POST_SUBSCRIPTION_SUCCESS,
    POST_SUBSCRIPTION_CARD,
    POST_SUBSCRIPTION_CARD_FAIL,
    POST_SUBSCRIPTION_CARD_SUCCESS,
    PUT_SUBSCRIPTION,
    PUT_SUBSCRIPTION_FAIL,
    PUT_SUBSCRIPTION_SUCCESS,
} = createSymbols([
    'DELETE_SUBSCRIPTION',
    'DELETE_SUBSCRIPTION_FAIL',
    'DELETE_SUBSCRIPTION_SUCCESS',
    'FETCH_SUBSCRIPTION',
    'FETCH_SUBSCRIPTION_FAIL',
    'FETCH_SUBSCRIPTION_SUCCESS',
    'POST_SUBSCRIPTION',
    'POST_SUBSCRIPTION_FAIL',
    'POST_SUBSCRIPTION_SUCCESS',
    'POST_SUBSCRIPTION_CARD',
    'POST_SUBSCRIPTION_CARD_FAIL',
    'POST_SUBSCRIPTION_CARD_SUCCESS',
    'PUT_SUBSCRIPTION',
    'PUT_SUBSCRIPTION_FAIL',
    'PUT_SUBSCRIPTION_SUCCESS',
]);

const fetchSubscription = (state) => state.set('isFetching', true);
const fetchSubscriptionSuccess = (state, action) => {
    return state
        .set('data', SubscriptionRecord(fromJS(action.payload.data)))
        .set('isFetching', false)
        .set('hasFetched', true);
};
const loadingTrue = (state) => state.set('loading', true);
const loadingFalse = (state) => state.set('loading', false);

export default baseReducer(initialState, {
    [DELETE_SUBSCRIPTION]: loadingTrue,
    [DELETE_SUBSCRIPTION_FAIL]: loadingFalse,
    [DELETE_SUBSCRIPTION_SUCCESS]: loadingFalse,
    [FETCH_SUBSCRIPTION]: fetchSubscription,
    [FETCH_SUBSCRIPTION_SUCCESS]: fetchSubscriptionSuccess,
    [POST_SUBSCRIPTION]: loadingTrue,
    [POST_SUBSCRIPTION_CARD]: loadingTrue,
    [POST_SUBSCRIPTION_CARD_FAIL]: loadingFalse,
    [POST_SUBSCRIPTION_CARD_SUCCESS]: loadingFalse,
    [POST_SUBSCRIPTION_FAIL]: loadingFalse,
    [POST_SUBSCRIPTION_SUCCESS]: loadingFalse,
    [PUT_SUBSCRIPTION]: loadingTrue,
    [PUT_SUBSCRIPTION_FAIL]: loadingFalse,
    [PUT_SUBSCRIPTION_SUCCESS]: loadingFalse,
});



// WEBPACK FOOTER //
// ./src/redux/subscription/reducer.js